// Every report-param key the combo block can persist, each set to null.

import { calcQuestionClearParams } from '@aytm/app/stats/page/question-views/components/lib/clear-params'

const QUESTION_PARAMS = ['qs', 'oe', 'cm', 'z', 's']

export const calcClearParams = ({ questionKey, answerVariants, batches, clusters } = {}) =>
  calcQuestionClearParams({ questionKey, answerVariants, batches, clusters, question: QUESTION_PARAMS })
